import { soap } from "../common";
const baseUrl = "/BLO/CatalogService.asmx";

const STARTPAGE = 0;
const DC = 30000;
const scList = [":", ",", "-", "_", "ㆍ", "!", "?"];
const blackList = ["개정판", "개정증보판", "개정 증보판", "완결", "완결판"];

export const SearchDetailbyPage = async (Loc, title, otwa1 = "IDX") => {
  //#region

  const parmas = {
    Loc: Loc,
    type: "all",
    StartPage: STARTPAGE,
    dc: DC,
    otod1: title,
    otwa1: otwa1,
    otbool1: "",
    otod2: "",
    otwa2: "",
    otbool2: "",
    otod3: "",
    otwa3: "",
    otyear1: "",
    otyear2: ""
  };
  const data = await soap("SearchDetailbyPage", parmas, baseUrl);
  return data;
  //#endregion
};

//검색 리스트
export const SearchList = async (Loc, JID) => {
  //#region
  const parmas = { Loc: Loc, JID: JID, StartPage: STARTPAGE, dc: DC };
  const data = await soap("SearchList", parmas, baseUrl);
  return data;
  //#endregion
};

//자료 가져오기
export const GetCnoFile = async (loc, Cno, FileType) => {
  //#region
  const params = { loc, Cno, FileType };
  const data = await soap("GetCnoFile", params, baseUrl);
  return data;
  //#endregion
};

export const copyCheck = async (
  loc,
  title,
  marcType,
  emarcType,
  otwa1 = "IDX"
) => {
  let bigo = "";
  let book = false;
  let ebook = false;
  const res1 = await SearchDetailbyPage(loc, title, otwa1);
  const JID = res1.split("^")[0];
  const count = res1.split("^")[1];
  const res2 = await SearchList(loc, JID);

  if (!res2) {
    return { book: book, ebook: ebook, bigo: bigo };
  }

  book = res2.filter(item => marcType.includes(item.marctype)).length > 0;
  ebook = res2.filter(item => emarcType.includes(item.marctype)).length > 0;
  bigo = "test";

  return { book: book, ebook: ebook, bigo: bigo };
};

/**
 *
 * @param {*} loc 기관코드
 * @param {*} rows
 * @param {*} titleIndex 서명 index
 * @param {*} marcType 단행본마크타입 배열
 * @param {*} emarcType 전자책마크타입 배열
 */
export const startJob = async (
  loc,
  title,
  marcType = ["A", "B"],
  emarcType = ["F"],
  otwa1 = "IDX"
) => {
  try {
    let data = { book: "checking", ebook: "checking", bigo: "checking" };
    const searchWords = getWords(title);
    data.bigo = searchWords.toString();
    for (const word of searchWords) {
      const check = await copyCheck(loc, word, marcType, emarcType, otwa1);
      const { book, ebook, bigo } = check;
      if (data.book == "checking" || data.book == "") {
        data.book = book ? "1" : "";
      }
      if (data.ebook == "checking" || data.ebook == "") {
        data.ebook = ebook ? "1" : "";
      }
      if ((data.book == "1") & (data.ebook == "1")) {
        console.log("단행본 전자책 다있음");
        return data;
      }
    }
    return data;
  } catch (e) {
    return { book: "error", ebook: "error", bigo: "error" };
  }
};

function getWords(searchTitle) {
  const array = new Array();
  const title = searchTitle.trim();
  arrayAdd(array, title); //전체 서명
  for (const sc in scList) {
    const words = filterWord(title, scList[sc], null);
    if (words) {
      for (const key in words) {
        const word = words[key];
        if (word.indexOf("(") > -1 || word.indexOf(")") > -1) {
          continue;
        }
        arrayAdd(array, word);
      }
    }
  }
  const words = filterWord(title, "(", ")");
  for (const key in words) {
    const word = words[key];
    arrayAdd(array, word);
  }

  const words2 = filterWord(title, "[", "]");
  for (const key in words2) {
    const word = words2[key];
    arrayAdd(array, word);
  }

  const series = checkSeries(title);
  arrayAdd(array, series);

  const regex1 = checkRegex(title, "[가-힣]편$|.[가-힣].편$");
  arrayAdd(array, regex1);

  const regex2 = checkRegex(title, "[0-9]권$");
  arrayAdd(array, regex2);

  if (regex1) {
    const r1 = checkRegex(regex1, "[0-9]권$");
    arrayAdd(array, r1);
  }
  if (regex2) {
    const r1 = checkRegex(regex2, "[가-힣]편$|.[가-힣].편$");
    arrayAdd(array, r1);
  }
  return array;
}

function arrayAdd(array, item) {
  if (!item) {
    return;
  }
  if (!array.includes(item.trim()) && !blackList.includes(item.trim())) {
    array.push(item.trim());
  }
}

function checkRegex(title, regax) {
  if (!title) {
    return null;
  }
  const matchArray = title.match(regax);
  if (matchArray) {
    const replaceStr = title.replace(matchArray[0].trim(), "").trim();
    return replaceStr;
  }
}

function filterWord(title, separator, separator2) {
  if (title.indexOf(separator) > -1) {
    if (separator2) {
      const index1 = title.indexOf(separator);
      const index2 = title.indexOf(separator2);
      if (index1 > -1 && index2 > -1) {
        const substr = title.substring(index1 + 1, index2);
        const replacestr = title.replace(separator + substr + separator2, "");
        return [replacestr, substr];
      } else {
        return null;
      }
    }
    const words = title.split(separator);
    return words;
  }
  return null;
}

function checkSeries(title) {
  if (!title) return null;
  const array = title.split(" ");
  if (array.length > 0) {
    const lastWord = array[array.length - 1];
    if (!isNaN(lastWord)) {
      return title.replace(lastWord, "");
    } else {
      return null;
    }
  }
}
